import { inject, injectable } from 'tsyringe';
import { OWWindowScreenAnchor } from '../../odk-ts';
import { LoggerService } from 'app-core/src/services/logger.service';
import { kDITokenOwTesterWindow } from 'app-core/src/constants/constants';
import {
  kNameOfNotificationWindowManagerService,
  INotificationWindowManagerService,
} from 'app-core/src/interfaces/notification-window-manager-service.interface';
import {
  ITesterWindowManagerServiceDelegate,
  kNameOfTesterWindowManagerService,
  ITesterWindowManagerService,
} from '../interfaces/tester-window-manager-service.interface';
import { Application } from 'app-core/src/models/application.model';
import { Game } from 'app-core/src/models/game.model';
import { IOWWindowWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-window-wrapper.interface';
import { kDITokenNotificationWindowScreenAnchor } from 'app-core/src/constants/injectionTokens';

// -----------------------------------------------------------------------------
@injectable()
export class TesterWindow implements ITesterWindowManagerServiceDelegate {
  private readonly logger = LoggerService.getCategory('TesterWindow');
  // ---------------------------------------------------------------------------

  public constructor(
    @inject(kNameOfNotificationWindowManagerService)
    private readonly notificationWinManager: INotificationWindowManagerService,
    @inject(kNameOfTesterWindowManagerService)
    private readonly testerWindowManagerService: ITesterWindowManagerService,
    @inject(kDITokenOwTesterWindow)
    private readonly owWindow: IOWWindowWrapper,
    @inject(kDITokenNotificationWindowScreenAnchor)
    private readonly owWindowScreenAnchor: OWWindowScreenAnchor,
  ) {}

  // ---------------------------------------------------------------------------
  async show() {
    this.testerWindowManagerService.addListener(this);
    this.owWindow.restore();
  }

  // ---------------------------------------------------------------------------
  // TesterWindowManagerServiceDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  async onTestingNotificationSet(
    game: Game,
    application: Application,
    useDevEnv: string,
  ) {
    const isShown = await this.notificationWinManager.isNotificationShown();
    this.testerWindowManagerService.notificationAlreadyRunning(isShown);
    if (!isShown) {
      this.notificationWinManager.show(game, application, true, useDevEnv);
      return true;
    }

    this.logger.info(
      'Notifications window is Open, ' +
        '  unable to load new notification until window is closed.',
    );

    return false;
  }

  // ---------------------------------------------------------------------------
  // NotificationWindowManagerServiceDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  closeNotificationWindow() {
    this.owWindowScreenAnchor.stop();
  }
}
